import React from 'react';
import { GoalsPage } from '../../pages/PerformanceReview/Goals2/GoalsPage';
import { useNamespacedTranslation } from '../../../../hooks/useNamespacedTranslation';
import { useFlairBreadcrumbHook } from '../../../../hooks/useFlairBreadcrumbHook';
import { GoalsContextProvider } from '../../pages/PerformanceReview/Goals2/GoalsContext/GoalsContext';

export const ManagerGoalsPage: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const t = useNamespacedTranslation('navigation.menuItems.teamDevelopment');

  useFlairBreadcrumbHook([
    { label: t('title') },
    { label: t('subMenuItems.goals.title') },
  ]);

  return (
    <div className="mt-2">
      <GoalsContextProvider isManagerView={true}>
        <GoalsPage />
      </GoalsContextProvider>
    </div>
  );
};
